import { Component } from '@angular/core';
import { EnrollmentFacade } from '@features/enrollment/facades/enrollment.facade';
import { LocaleFacade } from '@rd/core/facades/locale-facade/locale.facade';
import { LoyaltyCurrencyFacade } from '@rd/core/facades/loyalty-currency-facade/loyalty-currency.facade';
import { TenantFacade } from '@rd/core/facades/tenant-facade/tenant-facade';
import { UnleashFacade } from '@rd/core/facades/unleash-facade/unleash-facade.ts';
import { isNotNull } from '@rd/utils/isNotNull';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { vmaRebrandingThemeMaps } from './configs/vma-rebranding-configs';

@Component({
  selector: 'rd-lib-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class VmaAppComponent {
  isAppLoading$ = this.tenantFacade.getPageLoadingState$;
  isReady$ = combineLatest([
    this.localeFacade.selectedLocale$,
    this.loyaltyCurrencyFacade.getLoyaltyCurrencySelected$.pipe(
      filter(isNotNull),
    ),
    this.unleashFacade.isUnleashClientReady$,
    this.enrollmentFacade.loadEnrollmentsLoading$.pipe(
      map((isLoading) => !isLoading),
    ),
  ]).pipe(map((v) => v.every(Boolean)));

  constructor(
    private localeFacade: LocaleFacade,
    private tenantFacade: TenantFacade,
    private loyaltyCurrencyFacade: LoyaltyCurrencyFacade,
    private unleashFacade: UnleashFacade,
    private enrollmentFacade: EnrollmentFacade,
  ) {
    for (const [variableKey, themeValue] of Object.entries(
      vmaRebrandingThemeMaps,
    )) {
      document.documentElement.style.setProperty(variableKey, themeValue);
    }
  }
}
